import { api } from "@/shared/api/client";
import { queryClient } from "@/shared/lib/queryClient";
import { queryKeys } from "@/shared/lib/queryKeys";
import type { CategoryCreateDTO, CategoryGetDTO, CategoryUpdateDTO, PageCategoryGetDTO } from "@/shared/types/financial/category";
import { DEFAULT_PAGE_SIZE } from "@/shared/config/pagination";

const invalidateCategories = () => queryClient.invalidateQueries({ queryKey: queryKeys.categories.all });

export const categoryService = {
    getAll: async ({ page = 0, size = DEFAULT_PAGE_SIZE, sort = ["name,asc"], filter = {} }: { page?: number; size?: number; sort?: string[]; filter?: { id?: string; name?: string; }; } = {}): Promise<PageCategoryGetDTO> => {
        const response = await api.get<PageCategoryGetDTO>("/categories", {
            params: {
                page: Math.max(0, page - 1),
                size,
                sort,
                id: filter.id,
                name: filter.name
            },
        });
        return response.data;
    },

    getById: async (id: string): Promise<CategoryGetDTO> => {
        const response = await api.get(`/categories/${id}`);
        return response.data;
    },

    create: async (data: CategoryCreateDTO) => {
        const response = await api.post("/categories", data);
        void invalidateCategories();
        return response.data;
    },

    update: async (id: string, data: CategoryUpdateDTO) => {
        const response = await api.put(`/categories/${id}`, data);
        void invalidateCategories();
        return response.data;
    },

    delete: async (id: string) => {
        await api.delete(`/categories/${id}`);
        void invalidateCategories();
    },
};
